import { HttpTypes } from '@/types';
import { AxiosInstance, AxiosRequestConfig } from 'axios';

class Promotion {
  private client: AxiosInstance;
  private promotionPath = '/product/store/promotion';
  private routePath = '/product/store';

  public host = '';

  constructor(client: AxiosInstance) {
    client.interceptors.request.use();

    this.client = client;
  }

  interceptRequest(config: AxiosRequestConfig) {
    config.headers = {
      ...config.headers,
    };

    return config;
  }

  async list(
    data: HttpTypes.StorePromotionListPayload,
    is_recommend: boolean,
    token?: string
  ): Promise<HttpTypes.StorePromotionListResponse> {
    const result = await this.client.post(
      `${this.promotionPath}/list`,
      {
        ...data,
        is_recomendation: is_recommend,
      },
      {
        headers: {
          Origin: this.host,
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      }
    );
    return result.data;
  }

  async listProductPromo(
    slug: string,
    token?: string
  ): Promise<HttpTypes.StorePromotionListResponse> {
    const result = await this.client.get(`${this.routePath}/product-promotion/${slug}`, {
      headers: {
        Origin: this.host,
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    return result.data;
  }

  async reward(
    data: HttpTypes.StorePromotionRewardProductPayload,
    query?: HttpTypes.FindParams,
    token?: string,
    locationId?: string
  ): Promise<HttpTypes.StorePromotionProductRewardList> {
    const result = await this.client.post(`${this.routePath}/reward/product`, data, {
      params: query,
      headers: {
        Origin: this.host,
        'Content-Type': 'application/json',
        'X-Location-Id': locationId,
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    return result.data;
  }

  async rewardItem(
    data: HttpTypes.StorePromotionRewardProductItemPayload,
    query?: HttpTypes.FindParams,
    token?: string,
    locationId?: string
  ): Promise<HttpTypes.StorePromotionProductRewardListItem> {
    const result = await this.client.post(`${this.routePath}/reward/item`, data, {
      params: query,
      headers: {
        Origin: this.host,
        'Content-Type': 'application/json',
        'X-Location-Id': locationId,
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    return result.data;
  }

  async validatePromo(
    data: HttpTypes.StorePromotionPromoPayload,
    token: string
  ): Promise<HttpTypes.StorePromotionValidatePromoResponse> {
    const result = await this.client.post(`${this.promotionPath}/validate`, data, {
      headers: {
        Origin: this.host,
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    return result.data;
  }

  async validateVoucher(
    data: HttpTypes.StorePromotionVoucherPayload,
    token: string
  ): Promise<HttpTypes.StorePromotionValidateVoucherResponse> {
    const result = await this.client.post(`${this.promotionPath}/voucher/validate`, data, {
      headers: {
        Origin: this.host,
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    return result.data;
  }

  async apply(data: HttpTypes.StorePromotionApplyPayload, token?: string) {
    const result = await this.client.post(`${this.routePath}/apply-promotion`, data, {
      headers: {
        Origin: this.host,
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    return result.data;
  }

  async reset(cartId: string, token?: string) {
    const result = await this.client.post(
      `${this.routePath}/reset-promotion`,
      {
        cart_id: cartId,
      },
      {
        headers: {
          Origin: this.host,
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      }
    );
    return result.data;
  }

  async force(checkoutId: string, email?: string, token?: string) {
    const result = await this.client.post(
      `${this.routePath}/force-promotion`,
      {
        checkout_id: checkoutId,
        force_valid_promotions: true,
        email,
      },
      {
        headers: {
          Origin: this.host,
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      }
    );
    return result.data;
  }
}

export default Promotion;
